import React, { useEffect } from "react";
import { ContactReferenceModel, PurchasePaymentIntentModel } from "../models";
import { FlexContainer } from "@mindmemobile/mm-shared-global";
import styled from "styled-components";

type PaymentFormProps = {
  paymentIntent: PurchasePaymentIntentModel | null;
  onPaymentSuccess: (token: string) => void;
  onPaymentError: () => void;
  contact: ContactReferenceModel | null;
};

const PaymentFormWrapper = styled(FlexContainer)`
  &.multiple-payment-method-form-latest {
    .payment-form {
      margin: 0 -24px;
    }
    .default-payment-form {
      margin: 0px;
    }
  }
`;

declare global {
  interface Window {
    Forward: any;
  }
}

const PaymentForm: React.FC<PaymentFormProps> = ({
  paymentIntent,
  onPaymentSuccess,
  onPaymentError,
  contact,
}) => {
  let unmounted = false;
  let unmountPaymentElement: (() => void) | null = null;

  useEffect(() => {
    if (window.Forward) {
      renderPaymentForm();
    } else {
      console.error(
        "Payment form cannot be rendered: missing Forward library."
      );
    }

    // return () => {
    //   unmounted = true;
    //   if (typeof unmountPaymentElement === "function") {
    //     unmountPaymentElement();
    //     unmountPaymentElement = null;
    //   }
    //   // 🧹 Remove Apple Pay SDK injected by Forward
    //   const applePayScript = document.querySelector<HTMLScriptElement>(
    //     'script[src^="https://applepay.cdn-apple.com/jsapi"]'
    //   );
    //   if (applePayScript) applePayScript.remove();
    //   // Clear Apple Pay globals
    //   // @ts-ignore
    //   window.ApplePaySession = undefined;
    //   // @ts-ignore
    //   window.ApplePay = undefined;
    // };
  }, []);

  async function getPaymentElement() {
    return (
      typeof window !== "undefined" &&
      window.Forward.createPaymentElement({
        apiKey: process.env.REACT_APP_FISERV_API_KEY,
        clientSecret: paymentIntent?.clientSecret,
      })
    );
  }

  async function renderPaymentForm() {
    const paymentElement = await getPaymentElement();

    // // ✅ Check if unmounted before trying to mount
    // if (unmounted) return;

    // ✅ Check if parent exists before mounting
    const parent = document.getElementById("payment-form");
    if (!parent) {
      console.warn("Payment form parent element not found.");
      return;
    }

    unmountPaymentElement = paymentElement.mount("#payment-form", {
      onChange: (event: any) => {
        if (!event.ready) {
          console.log("Credit card input is incomplete");
        }
        onPaymentError();
      },
      onReady: (tokenize: any) => {
        tokenize();
        document.getElementById("pay-button")?.addEventListener("click", () => {
          const email = contact?.email;
          const fullName = `${contact?.firstName || ""} ${contact?.lastName || ""}`;
          tokenize({
            billingDetails: {
              address: { email: email, name: fullName },
            },
          });
        });
        onPaymentError();
      },
      onSuccess: async ({ token }: any) => {
        onPaymentSuccess(token);
      },
      onError: () => {
        onPaymentError();
      },
    });
  }

  return (
    <PaymentFormWrapper
      className={
        paymentIntent?.hasMultiplePaymentMethods()
          ? "multiple-payment-method-form-latest"
          : "custom-payment-method-form"
      }
    >
      <div id="payment-form" className="payment-form" />
    </PaymentFormWrapper>
  );
};

export default PaymentForm;
